<p><b>{{ title }}</b></p>
<p>{{ message }}</p>
<button type="button" mat-button 
    (click)="mdDialogRef.close()">{{ 'DIALOG.OKAY' | translate }}</button>
